import {APIService} from "../../common/APIService";
import {ProjectVisit} from "../../dto/ProjectVisit";
import {ProjectVisitMapConfig} from "../../dto/ProjectVisitMapConfig";
export class ProjectVisitService extends APIService {
  public async browseProjectVisits() {
    const json = await this.getJson<{data: object[]}>('project-visits')
    return json.data.map(item => ProjectVisit.fromJson(item))
  }

  public async read(id: string) {
    const json = await this.getJson<{data: object}>(`project-visits/${id}`)
    return ProjectVisit.fromJson(json.data)
  }

  public async add(projectId: string, taskId: string|null, name: string, type: string, amountOfDays?: number|null, shouldMakeTask?: boolean, taskType?: string|null) {
    const json = await this.postJson<{data: object[]}>('project-visits', {
      project_uuid: projectId,
      ...(taskId !== null ? {task_uuid: taskId} : {}),
      name: name,
      type: type,
      ...(amountOfDays != null ? {amount_of_days: amountOfDays} : {}),
      ...(shouldMakeTask ? {should_make_task: shouldMakeTask} : {}),
      ...((shouldMakeTask && taskType) ? {task_type: taskType} : {})
    })
    return ProjectVisit.fromJson(json.data)
  }

  public async edit(projectVisitId: string, name: string, type: string, status: string, date: Date, amountOfDays?: number|null) {
    const json = await this.putJson<{data: object[]}>(`project-visits/${projectVisitId}`, {
      name: name,
      type: type,
      status: status,
      date: date,
      ...(amountOfDays != null ? {amount_of_days: amountOfDays} : {}),
    })
    return ProjectVisit.fromJson(json.data)
  }

  public async editStatus(projectVisitId: string, fields: Partial<{ status: string }>) {
    const json = await this.patchJson<{data: object[]}>(`project-visits/${projectVisitId}`, {
      status: fields.status
    })
    return ProjectVisit.fromJson(json.data)
  }

  public async linkTask(projectVisitId: string, fields: Partial<{ task: string }>) {
    const json = await this.patchJson<{data: object[]}>(`project-visits/${projectVisitId}/link-task`, {
      task_uuid: fields.task
    })
    return ProjectVisit.fromJson(json.data)
  }

  public async unlinkTask(projectVisitId: string, fields: Partial<{ task: string }>) {
    const json = await this.patchJson<{data: object[]}>(`project-visits/${projectVisitId}/unlink-task`, {
      task_uuid: fields.task
    })
    return ProjectVisit.fromJson(json.data)
  }

  public async delete(projectVisitId: string) {
    await this.deleteJson(`project-visits/${projectVisitId}`)
  }


  // MAP CONFIGURATIONS
  public async browseMapConfigurations() {
    const json = await this.getJson<{ data: object[] }>(`map-configurations`)
    return json.data.map(item => ProjectVisitMapConfig.fromJson(item))
  }

  public async addMapConfiguration(withinNDays: number, color: string) {
    const json = await this.postJson<{ data: object }>(`map-configurations`, {
      within_x_days: withinNDays,
      color: color
    })

    return ProjectVisitMapConfig.fromJson(json.data)
  }

  public async editMapConfiguration(id: string, withinNDays: number, color: string) {
    const json = await this.putJson<{ data: object }>(`map-configurations/${id}`, {
      within_x_days: withinNDays,
      color: color
    })
    return ProjectVisitMapConfig.fromJson(json.data)
  }

  public async deleteMapConfiguration(id: string) {
     await this.deleteJson<{ data: object }>(`map-configurations/${id}`)
  }
}